/**
 * Mexico VAT (IVA) is a flat 16%. Every commission / fee amount stored on
 * SpotMe (closed deals, billing, host invoices, etc.) is the SUBTOTAL —
 * IVA is never embedded in the persisted number. We compute and display
 * it at render time.
 */
export const IVA_RATE = 0.16

export type IIvaBreakdown = {
  subtotal: number
  iva: number
  total: number
}

export function withIva(
  subtotal: number | null | undefined
): IIvaBreakdown | null {
  if (subtotal == null || !Number.isFinite(subtotal)) return null
  const iva = subtotal * IVA_RATE
  return {
    subtotal,
    iva,
    total: subtotal + iva
  }
}
